import React from 'react';
import { BRAND } from './brand';

// Brand lockup matching the home page (LandingPage.tsx BrandMark + .brand):
// the MD inTouch icon + "Add2Wallet" with the ".link" suffix in the home
// page's lime shade. SiteHeader, PageFooter and ErrorState all render
// through this component.
const Add2WalletLogo: React.FC<{ size?: number; showWordmark?: boolean }> = ({
  size = 28,
  showWordmark = true,
}) => (
  <span className="inline-flex items-center gap-2 select-none">
    <img
      src="/images/md_intouch_icon.png"
      alt=""
      width={size}
      height={size}
      style={{ borderRadius: Math.round(size * 0.26), display: 'block' }}
      aria-hidden
    />
    {showWordmark && (
      <span className="text-lg font-bold tracking-tight" style={{ color: BRAND.ink }}>
        Add2Wallet<span style={{ color: BRAND.limeDark }}>.link</span>
      </span>
    )}
  </span>
);

export default Add2WalletLogo;
